import * as React from "react";
import { SVGProps } from "react";

type CheckReqStatusIconProps = SVGProps<SVGSVGElement> & {
  circleColor?: string;
  iconColor?: string;
};

const CheckReqStatusIcon = (props: CheckReqStatusIconProps) => {

    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;


  return (<svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g id="check status">
      <rect width={32} height={32} fill="white" />
      <g id="page">
        <g id="back-page">
          <path
            d="M24 2H9C8.44772 2 8 2.44772 8 3V5H21C21.5523 5 22 5.44772 22 6V25.9659C22 25.9847 22.0153 26 22.0341 26H24C24.5523 26 25 25.5523 25 25V3C25 2.44772 24.5523 2 24 2Z"
            fill="#D9D9D9"
          />
          <path
            d="M8 5V3C8 2.44772 8.44772 2 9 2H24C24.5523 2 25 2.44772 25 3V25C25 25.5523 24.5523 26 24 26H22.0341C22.0153 26 22 25.9847 22 25.9659V6C22 5.44772 21.5523 5 21 5H8Z"
            stroke="black"
            strokeWidth={0.5}
          />
        </g>
        <path
          id="front-page"
          d="M6 5H21C21.5523 5 22 5.44772 22 6V28C22 28.5523 21.5523 29 21 29H10.3837C10.1367 29 9.8984 28.9086 9.71477 28.7433L5.33104 24.7979C5.12032 24.6083 5 24.3381 5 24.0546V6C5 5.44772 5.44772 5 6 5Z"
          stroke="black"
          strokeWidth={0.5}
        />
        <path
          id="fold-page"
          d="M10 29V24.5C10 24.2239 9.77614 24 9.5 24H5"
          stroke="black"
          strokeWidth={0.5}
          strokeLinecap="round"
        />
      </g>
      <g id="lines">
        <g id="Line 49" filter="url(#filter0_d_13_422)">
          <line
            x1={8.5}
            y1={15.5}
            x2={15.5}
            y2={15.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 49_2" filter="url(#filter1_d_13_422)">
          <line
            x1={8.5}
            y1={17.5}
            x2={12.5}
            y2={17.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 50" filter="url(#filter2_d_13_422)">
          <line
            x1={8.5}
            y1={19.5}
            x2={11.5}
            y2={19.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 55" filter="url(#filter3_d_13_422)">
          <line
            x1={8.5}
            y1={21.5}
            x2={11.5}
            y2={21.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 54" filter="url(#filter4_d_13_422)">
          <line
            x1={8.5}
            y1={13.5}
            x2={18.5}
            y2={13.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 56" filter="url(#filter5_d_13_422)">
          <line
            x1={8.5}
            y1={9.5}
            x2={18.5}
            y2={9.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 57" filter="url(#filter6_d_13_422)">
          <line
            x1={8.5}
            y1={7.5}
            x2={18.5}
            y2={7.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
        <g id="Line 58" filter="url(#filter7_d_13_422)">
          <line
            x1={8.5}
            y1={11.5}
            x2={18.5}
            y2={11.5}
            stroke="black"
            strokeLinecap="round"
          />
        </g>
      </g>
      <g id="circle">
        <circle
          id="inner-circle"
          cx={20.5}
          cy={23.5}
          r={7.25}
          fill={circleColor || "#D9D9D9"}
          stroke={iconColor || "black"}
          strokeWidth={0.5}
        />
        <path
          id="icon"
          d="M19.419 25.3409V25.2855C19.4252 24.6977 19.4868 24.2299 19.6037 23.8821C19.7207 23.5343 19.8869 23.2527 20.1023 23.0373C20.3177 22.8218 20.5762 22.6233 20.8779 22.4418C21.0594 22.331 21.2226 22.2002 21.3672 22.0494C21.5119 21.8955 21.6257 21.7185 21.7088 21.5185C21.795 21.3184 21.8381 21.0968 21.8381 20.8537C21.8381 20.5521 21.7673 20.2905 21.6257 20.0689C21.4842 19.8473 21.2949 19.6765 21.0579 19.5565C20.8209 19.4364 20.5578 19.3764 20.2685 19.3764C20.0161 19.3764 19.773 19.4287 19.5391 19.5334C19.3052 19.638 19.1097 19.8027 18.9528 20.0273C18.7958 20.252 18.705 20.5459 18.6804 20.9091H17.5171C17.5417 20.3859 17.6771 19.9381 17.9233 19.5657C18.1726 19.1933 18.5004 18.9086 18.9066 18.7116C19.3159 18.5147 19.7699 18.4162 20.2685 18.4162C20.8101 18.4162 21.281 18.5239 21.6811 18.7393C22.0843 18.9548 22.3951 19.2502 22.6137 19.6257C22.8352 20.0012 22.946 20.429 22.946 20.9091C22.946 21.2476 22.8937 21.5539 22.7891 21.8278C22.6875 22.1017 22.5398 22.3464 22.3459 22.5618C22.1551 22.7772 21.9243 22.968 21.6534 23.1342C21.3826 23.3035 21.1656 23.482 21.0025 23.6697C20.8394 23.8544 20.7209 24.0745 20.647 24.3299C20.5732 24.5853 20.5332 24.9039 20.527 25.2855V25.3409H19.419ZM20.01 28.0739C19.7822 28.0739 19.5868 27.9923 19.4237 27.8292C19.2605 27.6661 19.179 27.4706 19.179 27.2429C19.179 27.0151 19.2605 26.8197 19.4237 26.6566C19.5868 26.4935 19.7822 26.4119 20.01 26.4119C20.2377 26.4119 20.4331 26.4935 20.5962 26.6566C20.7594 26.8197 20.8409 27.0151 20.8409 27.2429C20.8409 27.3937 20.8025 27.5322 20.7255 27.6584C20.6516 27.7846 20.5516 27.8861 20.4254 27.9631C20.3023 28.0369 20.1638 28.0739 20.01 28.0739Z"
          fill={iconColor || "black"}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_13_422"
        x={4}
        y={15}
        width={16}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_13_422"
        x={4}
        y={17}
        width={13}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_13_422"
        x={4}
        y={19}
        width={12}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_13_422"
        x={4}
        y={21}
        width={12}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_13_422"
        x={4}
        y={13}
        width={19}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_13_422"
        x={4}
        y={9}
        width={19}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_13_422"
        x={4}
        y={7}
        width={19}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_13_422"
        x={4}
        y={11}
        width={19}
        height={9}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13_422"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13_422"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
  )
}

export default CheckReqStatusIcon;